import { ajax } from 'js/functions';
import { create_div } from 'js/utils';

export default class MB_Load_All {

    constructor(mb){
        this.mb = mb;
        this.posts_per_request = 50;
        this.offset = mb.total;
        this.is_done = false;

        this.mb.hooks.after_add_items = [];

        this.get_initial_ids();
        this.query();
    }

    query(){

        const payload = {
            query_args: this.get_query_args(),
            mb_settings: this.get_ajax_settings(),
            check_more_posts: true,
            offset: this.offset,
        }
        
        ajax('mb/query', payload, (res)=>{
            this.process_result(res);
        })
    }
    
    get_query_args(){
        const query_args = {...this.mb.settings.query_args};
        query_args.showposts = this.posts_per_request;
        query_args.offset = this.offset;
        return query_args;
    }

    process_result(res){
        this.offset += parseInt(res.count);
        this.add_items(res.html);

        if( res.have_more_posts ) {
            this.query();
        }
        else {
            this.is_done = false;
        }
    }
    
    add_items(html){

        const temp = create_div('');
        temp.innerHTML = html;

        const items = temp.children;
        
        for( let i = 0; i < items.length; i++ ) {
            const item = items[i];
            if( this.initial_ids.includes(item.dataset.id) ) {
                continue;
            }
            item.classList.add('mb_hidden');
            // this.mb.container.append(item);
        }

        // this.mb.isotope.addItems(items);
        this.mb.isotope.insert(items);

        this.mb.hooks.after_add_items.forEach(action=>action());
    }
    
    get_initial_ids(){
        this.initial_ids = [];
        this.mb.container.querySelectorAll('.mb_item').forEach(item=>{
            this.initial_ids.push(item.dataset.id);
        })
    }
    
    get_ajax_settings(){
        return {
            item_template: this.mb.settings.item_template,
            item_data: this.mb.settings.item_data,
            filters_attr: this.mb.settings.filters_attr,
        };
    }
    
}